import React from "react";
import "./loading.css";

const Loader = () => {
  return (
    <div className="d-flex justify-content-center">
      <div className="lds-dual-ring my-3"></div>
    </div>
  );
};

export default Loader;
